<template>
  <div class="internal">
    <section class="table">
      <transition name="fade" mode="out-in">
        <div class="container" v-if="loaded">
          <h1 class="title-default">Documentos</h1>

          <div class="responsive" v-if="!isMobile()">
            <table v-if="items && items.length">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Título</th>
                  <th>Descrição</th>
                  <th>Publicado em</th>
                  <th>Download</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, i) of items" :key="i">
                  <td>{{ item.categoria.nome }}</td>
                  <td>{{ item.titulo }}</td>
                  <td>{{ item.descricao }}</td>
                  <td class="aligncenter">{{ new Date(item.dataPublicacao) | moment('DD/MM/YYYY HH:mm:ss') }}</td>
                  <td class="aligncenter"><a :href="item.isExterno ? item.url : urlFiles + 'cliente/documentos/' + item.url" target="_blank" class="icon -download"></a></td>
                </tr>
              </tbody>
            </table> <!-- /table -->

            <table v-else class="empty">
              <thead>
                <tr>
                  <th colspan="5"><p class="aligncenter">Nenhum item.</p></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table> <!-- /table -->
          </div>

          <div class="docs-list" v-if="isMobile()">
            <ul v-if="items && items.length">
              <li v-for="(item, i) of items" :key="i">
                <div class="header">
                  <span>{{ item.categoria.nome }}</span>
                  <time>{{ new Date(item.dataPublicacao) | moment('DD/MM/YYYY HH:mm:ss') }}</time>
                </div>
                <div class="description">
                  <h2>{{ item.titulo }}</h2>
                  <p>{{ item.descricao }}</p>
                </div>
                <div class="button">
                  <a :href="item.isExterno ? item.url : urlFiles + 'cliente/documentos/' + item.url" target="_blank"><span>Download</span> <i class="icon -download"></i></a>
                </div>
              </li>
            </ul>

            <ul v-else>
              <li>
                <div class="description -center">
                  <h2>Nenhum item.</h2>
                </div>
              </li>
            </ul>
          </div>
        </div> <!-- /.container -->
      </transition>
    </section> <!-- /.table -->
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'

export default {
  name: 'home',

  data () {
    const data = {
      items: [],
      loaded: false,

      urlFiles: Vue.prototype.urlFiles
    }

    return data
  }, // data()

  beforeMount () {
    this.loadList()
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadList () {
      let { empreendimentoIdWeb, unidade, codBloco } = this.$store.state.contratoAtual

      try {
        let xhr = await PagesService.getDocumentos(empreendimentoIdWeb, unidade)

        this.items = xhr.filter(item => {
          if (!item.isAtivo) return false

          if (item.isGeral) return true

          if (item.unidades && item.unidades.length) {
            const [ unidade ] = item.unidades

            return codBloco === unidade.codigoBloco
          }

          return false
        })
        this.loaded = true
      } catch (e) {
        console.error('Falha ao recuperar documentos', e)
      }
    }, // loadList()

    isMobile () {
      return screen.width <= 1024
    } // isMobile()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section
    &.table
      table
        display: table

      table.empty tbody tr td
        width: 100%

      .responsive
        table
          th,
          td
            width: auto

            &:nth-of-type(2)
              max-width: 200px

  @media (max-width: 767px)
    section.table
      .responsive
        table
          th
            &:first-child,
            // &:nth-child(2),
            &:nth-child(4)
              display: none

          td
            &:first-child,
            // &:nth-child(2),
            &:nth-child(4)
              display: none

      .docs-list
        ul
          width: 100%
          display: flex
          flex-direction: column

          li
            +box-border
            font-size: 13px
            margin-bottom: 20px

            .header
              display: flex
              justify-content: space-between
              padding: 5px 15px
              border-bottom: 2px solid #ddd

            .description
              padding: 10px 15px 20px

              h2
                font-weight: 700
                margin-bottom: 20px

              &.-center
                padding: 10px 15px

                h2
                  text-align: center
                  margin-bottom: 0

            .button
              display: flex
              justify-content: center
              padding-bottom: 20px

              a
                display: flex
                align-items: center
                text-transform: uppercase
                color: map-get($colors, primary)
                font-weight: 700
                font-size: 18px

                span:not(.icon)
                  margin-right: 10px

                span
                  &.icon
                    &.-download
                    width: 22px !important
                    height: 27px !important

</style>
